<template>
	<div class="test-content flex start-v">
		<div :data-index="currentIndex+1" class="content">
			<div class="scroll-view">{{currentQuestion?.stem}}</div>
		</div>
		<!-- 0-单选题 2-判断题 -->
		<!-- 显示正确：1-是答案且被选中 2-是答案但选择错误选项 -->
		<!-- 显示错误：1-有选中但不是答案 -->
		<div v-if="currentQuestion?.type==0||currentQuestion?.type==2" :class="{'judge':currentQuestion?.type==2}" class="option flex between-v">
			<p v-for="(item,index) in currentQuestion?.option" :key="index" 
			:class="{
					'success':currentQuestion.answer.includes(item)&&params.subjects[currentIndex]?.answer.includes(item)||currentQuestion.answer.includes(item)&&params.subjects[currentIndex]?.answer?.length,
					'err':params.subjects[currentIndex]?.answer.includes(item)&&optionError}"
				class="flex between">
				<span>{{currentQuestion.type==0?letterList[index]:''}}</span>
				<span class="text-ellipsis">{{item}}</span>
				<span></span>
			</p>
		</div>

		<!-- 1-多选题 -->
		<!-- 显示正确：1-是答案且被选中 2-是答案但有错误选项 -->
		<!-- 显示错误：1-有选中但不是答案-->
		<div v-if="currentQuestion?.type==1" class="option flex between-v">
			<p v-for="(item,index) in currentQuestion?.option" :key="index" :class="{
					'success':currentQuestion.answer.includes(item)&&params.subjects[currentIndex]?.answer.includes(item)||currentQuestion.answer.includes(item)&&optionError,
					'err':params.subjects[currentIndex]?.answer.includes(item)&&!currentQuestion.answer.includes(item)}" class="flex between">
				<span>{{letterList[index]}}</span>
				<span class="text-ellipsis">{{item}}</span>
				<span></span>
			</p>
		</div>

		<div class="btns flex between">
			<button @click="currentIndex-=1" v-if="preQuestion" class="btn-full">上一题</button>
			<!-- class-done 完成答题 -->
			<button v-if="nextQuestion" @click="toNextQuestion" :class="{'done':!end}" class="btn-full">下一题</button>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		questionList: {},
	},

	computed: {
		preQuestion() {
			return (
				this.currentIndex != 0 &&
				this.currentIndex < this.questionList.length
			);
		},
		nextQuestion() {
			return this.currentIndex != this.questionList.length - 1;
		},
		end() {
			return (
				this.currentIndex &&
				this.currentIndex == this.questionList.length - 1
			);
		},
		currentQuestion() {
			return this.questionList[this.currentIndex];
		},
		// 判断当前题目是否答错
		optionError() {
			let answer = this.currentQuestion?.answer;
			let option = this.params.subjects[this.currentIndex]?.answer;
			let errOp = [];
			if (option?.length) {
				errOp = option.filter((item) => {
					return !answer.includes(item);
				});
			}
			if(errOp.length) this.params.subjects[this.currentIndex].isCorrect = 0;
			else this.params.subjects[this.currentIndex].isCorrect = 1;
			return errOp.length;
		},
	},
	watch: {
		questionList(newVal) {
			this.params.testId = this.$route.query.testId;
			this.questionList.forEach((item) => {
				this.params.subjects.push({
					subjectId: item.id,
					answer: item.userAnswer||[],
					isCorrect: 0,
				});
			});
		},
	},
	data() {
		return {
			letterList: ["A", "B", "C", "D", "E", "F"],
			currentIndex: 0,
			questionEnd: false,
			params: {
				testId: undefined,
				subjects: [],
			},
			review: false,
		};
	},
	methods: {
		reStart() {
			this.review = true;
			this.currentIndex = 0;
			this.questionEnd = false;
		},
		toNextQuestion() {
			this.currentIndex += 1;
		},
	},
};
</script>

<style lang="less" scoped>
.test-content {
	flex: 1;
	width: 100%;
	.content {
		flex: 1;
		width: 100%;
		// max-height: 167/@rem;
		max-height: 250 / @rem;
		padding: 23 / @rem 17 / @rem;
		background-color: rgba(250, 224, 178, 0.84);
		border-radius: 12 / @rem;
		color: rgba(116, 46, 0, 1);
		font-size: 14 / @rem;
		position: relative;
		.scroll-view {
			height: 100%;
			overflow: auto;
			letter-spacing: 1 / @rem;
		}
		&::before {
			content: "";
			display: flex;
			position: absolute;
			left: 50%;
			top: -15 / @rem;
			margin-left: -11 / @rem;
			width: 33 / @rem;
			height: 33 / @rem;
			border-radius: 50%;
			background-image: url(~@img/icon/ui_topic.png);
			background-repeat: no-repeat;
			background-size: contain;
		}
		&::after {
			content: attr(data-index);
			display: flex;
			position: absolute;
			left: 50%;
			top: -15 / @rem;
			margin-left: -11 / @rem;
			width: 33 / @rem;
			height: 33 / @rem;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-size: 23 / @rem;
			font-weight: bold;
			color: white;
		}
	}
	.option {
		width: 100%;
		height: 280 / @rem;
		padding: 30 / @rem 0;
		p {
			height: 43 / @rem;
			padding: 0 11 / @rem;
			font-size: 17 / @rem;
			font-weight: bold;
			text-align: center;
			color: rgba(116, 46, 0, 1);
			border-radius: 12 / @rem;
			background-color: rgba(250, 227, 186, 1);
			span:nth-child(2) {
				flex: 1;
				padding: 0 6 / @rem;
			}
			span:last-child {
				display: flex;
				width: 30 / @rem;
				&::after {
					content: "";
					display: flex;
					width: 29 / @rem;
					height: 29 / @rem;
				}
			}

			&.success {
				color: white;
				background-color: rgba(255, 162, 22, 1);
				span:last-child {
					&::after {
						background-image: url(~@img/icon/ui_correct.png);
						background-size: contain;
						background-repeat: no-repeat;
					}
				}
			}
			&.err {
				color: white;
				background-color: rgba(233, 80, 0, 1);
				span:last-child {
					&::after {
						background-image: url(~@img/icon/ui_error.png);
						background-size: contain;
						background-repeat: no-repeat;
					}
				}
			}
		}
	}
	.option.judge {
		
		height: 280 / @rem;
		padding: 50 / @rem 0;
		p {
			height: 69 / @rem;
		}
	}
}

.btns {
	width: 100%;
	padding-top: 10 / @rem;
	.btn-full {
		&:nth-child(2) {
			margin-left: 20 / @rem;
		}
		&.done {
			background: linear-gradient(180deg, #fea42e 0%, #e95000 100%);
		}
	}
}
</style>
